module.exports = __webpack_public_path__ + "img/logo.38127d16.svg";